import React from 'react';
import Modal from '../../../Modal';

const Library = ({isOpen, onClose, title, assets, onSelect}) => {
    return <Modal isOpen={!!isOpen} setIsOpen={onClose} title={title} dismissible>
        <div className="flex flex-row flex-wrap justify-around gap-2">
            {assets.map(asset => {
                return <div key={asset.id}
                    className="w-[100px] h-[100px] rounded-md border flex items-center justify-center overflow-hidden cursor-pointer bg-cover"
                    style={{backgroundImage: `url(${asset.thumbnail})`}}
                    onClick={() => onSelect(asset.id)}
                />
            })}
        </div>
    </Modal>
}

export default Library;
